import { COMPONENT_IDS } from "../storage2ComponentIDs";
class StabilityZonesComponent {
    constructor({ stabilityZones, stable, sectionPointsRequired }) {
        this.typeId = StabilityZonesComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
        this.stabilityZones = stabilityZones;
        this.stable = stable;
        this.sectionPointsRequired = sectionPointsRequired;
    }
    eq() {
        // This should be replaced by an actual check! :)
        return false;
    }
}
StabilityZonesComponent.id = COMPONENT_IDS.STABILITY_ZONES;
export default StabilityZonesComponent;
